/**
 * 审批系统翻译 - 中文
 * Approval System - Chinese
 * 
 * TODO: 从 zh.old.ts 完整迁移所有审批相关翻译
 */
export const approvalsZh = {
  // 流程节点类型
  nodeTypes: {
    START: {
      label: '开始',
      description: '流程开始节点',
    },
    END: {
      label: '结束',
      description: '流程结束节点',
    },
    USER_TASK: {
      label: '审批节点',
      description: '需要人员审批的节点',
    },
    CC: {
      label: '抄送节点',
      description: '发送抄送通知',
    },
    EXCLUSIVE_GATEWAY: {
      label: '条件分支',
      description: '根据条件选择分支',
    },
    PARALLEL_GATEWAY: {
      label: '并行分支',
      description: '并行执行多个分支',
    },
  },

  // 审批人类型（types.ts）
  approverTypesConfig: {
    INITIATOR_MANAGER: {
      label: '直接上级',
      description: '发起人的直接上级',
    },
    MANAGER_CHAIN: {
      label: '连续上级',
      description: '逐级审批至部门负责人',
    },
    FIXED_USER: {
      label: '指定人员',
      description: '固定的审批人员',
    },
    ROLE: {
      label: '指定角色',
      description: '具有特定角色的人员',
    },
    DEPARTMENT: {
      label: '部门负责人',
      description: '指定部门的负责人',
    },
    FORM_FIELD: {
      label: '表单字段',
      description: '从表单字段获取审批人',
    },
  },

  // 审批模式（types.ts）
  approvalModesConfig: {
    SINGLE: {
      label: '单人审批',
      description: '只需一人审批',
    },
    AND: {
      label: '会签',
      description: '需要所有人都通过',
    },
    OR: {
      label: '或签',
      description: '任一人通过即可',
    },
    SEQUENTIAL: {
      label: '顺序审批',
      description: '按顺序依次审批',
    },
  },

  // 验证消息（types.ts）
  validationMessages: {
    mustHaveStartNode: '流程必须有一个开始节点',
    onlyOneStartNode: '流程只能有一个开始节点',
    mustHaveEndNode: '流程必须有一个结束节点',
    onlyOneEndNode: '流程只能有一个结束节点',
  },

  // 流程属性面板（ProcessPropertyPanel.tsx）
  propertyPanel: {
    startNodeDesc: '流程开始节点',
    endNodeDesc: '流程结束节点',
    noOtherConfig: '无需其他配置',
    selectApproverType: '选择审批人类型',
    selectCCType: '选择抄送对象类型',
    conditionName: '条件名称',
    parallelGateway: '并行网关',
    conditionalGateway: '条件网关',
    parallelGatewayDesc: '所有分支并行执行',
    conditionalGatewayDesc: '根据条件选择其中一个分支执行',
    actions: {
      approve: '通过',
      reject: '驳回',
      return: '退回',
      forward: '转发',
      addSign: '加签',
    },
  },

  // Lark风格流程预览（LarkProcessPreview.tsx）
  larkPreview: {
    notSet: '未设置',
    currentNode: '当前节点',
    completed: '已完成',
    rejected: '已拒绝',
    allRequired: '会签',
    anyOne: '或签',
    initiator: '发起人',
    submitter: '提交人',
    processEnd: '流程结束',
    noApprovalNodes: '暂无审批节点',
    directSubmit: '表单提交后将直接完成',
    nodeTypeLabels: {
      userTask: '审批人',
      cc: '抄送人',
      start: '发起',
      end: '结束',
      exclusiveGateway: '条件分支',
      parallelGateway: '并行分支',
    },
  },

  // 审批流程时间线（LarkProcessPreview.tsx - 完整流程展示）
  timeline: {
    skipped: '已跳过',
    returned: '已退回',
    pending: '待执行',
    skippedTooltip: '流程已终止，此节点未执行',
    pendingTooltip: '待执行',
    processCompleted: '流程已通过',
    processRejected: '流程已拒绝',
    processWithdrawn: '流程已撤回',
    processTerminated: '流程已终止',
    processFailed: '流程执行失败',
  },

  // ⭐ 操作类型（Action Types）
  actions: {
    // 普通审批操作
    SUBMIT: '提交',
    APPROVE: '通过',
    REJECT: '拒绝',
    RETURN: '退回',
    FORWARD: '转交',
    WITHDRAW: '撤回',
    APPROVER_WITHDRAW: '审批人撤回',
    ADD_SIGN: '加签',
    CLAIM: '认领',
    UNCLAIM: '取消认领',
    DELEGATE: '委托',
    COMMENT: '评论',
    REMIND: '催办',
    EXECUTE: '执行',

    // 自动操作
    AUTO_APPROVE: '自动通过',
    AUTO_REJECT: '自动拒绝',
    ESCALATE: '自动升级',

    // 管理员操作
    ADMIN_APPROVE: '管理员通过',
    ADMIN_REJECT: '管理员拒绝',
    ADMIN_TERMINATE: '管理员强制终止',
    ADMIN_REASSIGN: '管理员重新分配',
  },

  // ⭐ 管理员操作徽章（Admin Action Badges）
  adminBadges: {
    adminAction: '管理员操作',
    adminTerminate: '管理员强制终止',
    adminApprove: '管理员通过',
    adminReject: '管理员拒绝',
    adminReassign: '管理员重新分配',
  },

  // ⭐ 警告和提示消息（Warnings and Alerts）
  warnings: {
    // 管理员操作警告
    adminOperationWarning: '管理员介入：此操作由管理员代为执行',  // ⭐ 按文档规范修正
    adminTerminateWarning: '流程已被管理员强制结束，所有后续节点已取消',
    adminApproveWarning: '管理员直接通过：{reason}',
    adminRejectWarning: '管理员直接拒绝：{reason}',
    adminReassignWarning: '⚠️ 管理员介入：审批人已被重新分配',
    adminReassignNotice: '管理员 {admin} 将此任务重新分配给 {target}',

    // 系统错误
    systemErrorAlert: '流程异常终止，请联系技术支持',
    systemErrorDetails: '技术详情',
    showDetails: '查看',
    hideDetails: '隐藏',

    // 自动操作说明
    autoApprovalInfo: '自动审批说明：{reason}',
    autoApprovalTitle: '自动审批说明：',
    
    // ⭐ 前缀标签
    rejectReasonLabel: '拒绝原因：',
    withdrawReasonLabel: '撤回原因：',
    terminateReasonLabel: '终止原因：',
    errorMessageLabel: '错误信息：',
  },

  // 空态
  emptyStates: {
    adminTitle: '当前没有需要干预的流程',
    adminDesc: '只显示运行中的流程',
    noData: '暂无数据',
    noFormData: '暂无表单数据',
    noFormsAvailable: '暂无可用表单',
    noCategories: '暂无分类',
  },

  // 钉钉风格设计器（DingStyleDesigner.tsx）
  dingDesigner: {
    pleaseSetApprover: '请设置审批人',
    nodeCategories: {
      human: '人工节点',
      branch: '分支节点',
    },
    defaultNodeNames: {
      start: '发起',
      end: '结束',
      approver: '审批人',
      cc: '抄送人',
      conditionalBranch: '条件分支',
      parallelBranch: '并行分支',
      node: '节点',
    },
  },

  // 钉钉流程设计器（DingProcessDesigner.tsx）
  dingProcessDesigner: {
    executor: '执行人',
    initiator: '发起人',
    approver: '审批人',
    ccPerson: '抄送人',
    processEnd: '流程结束',
    endNode: '结束',
    humanNodes: '人工节点',
    branchNodes: '分支节点',
    clickToEdit: '点击节点编辑 · 点击 + 添加节点',
    deleteNode: '删除节点',
    deleteCondition: '删除条件分支',
    deleteBranch: '删除分支',
    deleteParallel: '删除并行分支',
    minOneBranch: '至少保留1个分支。如需删除，请删除整个条件分支节点',
    otherCases: '其他情况',
    condition: '条件',
    otherCasesDesc: '其他情况进入此流程',
    pleaseSetCondition: '请设置条件',
    pleaseSet: '请设置{type}',
    inputBranchName: '输入分支名称',
    expressionExample: '表达式示例: ${amount} > 5000 或 ${type} == \'交通费\'',
    addCondition: '添加条件',
    addBranch: '添加分支',
    priority: '优先级{priority}',
    parallelExecution: '并行执行',
    parallel: '并行',
    branch: '分支{number}',
    clickToAddNode: '点击+添加节点',
    nodeCount: '{count}个节点',
    continueAfterAll: '全部完成后继续',
    conditionalBranch: '条件分支',
    parallelBranch: '并行分支',
    condition1: '条件1',
    condition2: '条件2',
    branch1: '分支1',
    branch2: '分支2',
    // 审批人类型标签（getConfigLabel）
    configLabels: {
      initiatorManager: '发起人的直接上级',
      initiatorManagerLevel: '发起人第{level}级上级',
      managerChain: '连续上级审批',
      fixedUser: '指定人员',
      role: '指定角色',
      department: '部门负责人',
      formField: '表单字段',
    },
  },

  // 基础
  title: '审批中心',
  subtitle: '待审批事项管理',
  
  // 状态标签
  urgent: '紧急任务',
  overdue: '已逾期',
  
  // 详情页
  detail: {
    loadError: '加载审批详情失败',
    title: '审批详情',
    basicInfo: '基本信息',
    processInfo: '流程信息',
    formData: '表单数据',
    history: '审批历史',
    retryConfirm: '确认重试启动工作流？',
    retrySuccess: '重试成功',
    retryFailed: '重试失败',
    noBusinessData: '暂无业务数据',
    loading: '加载中...',
    retrying: '重试中...',
    retryWorkflow: '重试工作流',
    approvalProcess: '审批流程',
    countersignMode: '会签模式（需所有审批人同意）',
    orSignMode: '或签模式（任一审批人同意即可）',
    ccUsers: '抄送 {count} 人',
    processName: '流程名称',
    processVersion: '流程版本',
    processKey: '流程标识',
    initiator: '发起人',
    startTime: '开始时间',
    endTime: '结束时间',
    instanceId: '实例ID',
    expenseTodo: '报销单表单开发中...',
    purchaseTodo: '采购单表单开发中...',
    unsupportedType: '不支持的业务类型',
    loadFailed: '加载失败',
    back: '返回',
    formInfo: '表单信息',
    submitter: '提交人',
    ccMembersCount: '抄送{count}人',
    members: '成员',
    currentNode: '当前节点',
    completed: '已完成',
    currentApprovers: '当前审批人',
  },
  
  // 操作
  approve: '通过',
  reject: '拒绝',
  withdraw: '撤回',
  comment: '评论',
  approveSuccess: '审批通过成功',
  approveFailed: '审批通过失败',
  rejectSuccess: '审批拒绝成功',
  rejectFailed: '审批拒绝失败',
  rejectReasonRequired: '拒绝理由不能为空',
  
  // 状态
  pending: '待审批',
  approved: '已通过',
  rejected: '已拒绝',
  cancelled: '已取消',
  
  // 状态映射
  statuses: {
    pending: '待审批',
    approved: '已通过',
    rejected: '已拒绝',
    cancelled: '已取消',
    running: '进行中',
    completed: '已完成',
    terminated: '已终止',
  },
  
  // 审批结果映射
  results: {
    approve: '通过',
    approved: '已通过',
    reject: '拒绝',
    rejected: '已拒绝',
    withdraw: '撤回',
    withdrawn: '已撤回',
    transfer: '转交',
    transferred: '已转交',
  },
  
  // 业务类型映射
  businessTypes: {
    work_record: '加班记录',
    leave: '请假',
    expense: '报销',
    purchase: '采购',
  },
  
  // 导航
  all: '全部',
  pendingMyApproval: '待我审批',
  ccToMe: '抄送我的',
  myCreated: '我创建的',
  myInitiated: '我提交的',
  myProcessed: '我审批的',
  adminProcessing: '管理员处理',
  adminAnalytics: {
    tabLabel: '数据中心',
    title: '管理员数据中心',
    subtitle: '按表单查看提交与审批数据，可点击筛选说明了解每项用途。',
    filterGuide: '筛选说明',
    filterGuideSubtitle: '每个筛选项都会影响统计与明细结果。',
    settingsDescription: '配置导出记录的保留策略。',
    exportDescription: '按当前筛选条件导出数据。',
    settings: '导出设置',
    export: '导出',
    exportTitle: '导出数据',
    exportFormatLabel: '导出格式',
    exportFormatPlaceholder: '选择格式',
    exportFormatHint: '请选择导出文件格式。',
    exportFormats: {
      xlsx: 'XLSX',
      csv: 'CSV',
    },
    exportQueued: '导出任务已创建：{id}',
    settingsSaved: '设置已保存',
    filters: {
      formLabel: '表单',
      formPlaceholder: '选择表单',
      formHint: '按表单类型筛选统计与明细',
      approvalLabel: '是否需要审批',
      approvalPlaceholder: '审批类型',
      approvalHint: '区分需要审批与直接完成的表单',
      statusLabel: '状态',
      statusPlaceholder: '状态',
      statusHint: '按流程状态筛选提交记录',
      organizationLabel: '组织',
      organizationPlaceholder: '组织',
      organizationHint: '限定提交人所属组织',
      departmentLabel: '部门',
      departmentPlaceholder: '部门',
      departmentHint: '限定提交人所属部门',
      submitterLabel: '发起人',
      submitterPlaceholder: '选择用户',
      submitterHint: '按用户筛选提交记录',
      submitterClear: '清除',
      submitterSelect: '选择发起人',
      timeFromLabel: '开始日期',
      timeFromHint: '统计起始日期（含）',
      timeToLabel: '结束日期',
      timeToHint: '统计结束日期（含）',
      keywordLabel: '关键字',
      keywordPlaceholder: '关键字/业务编号',
      keywordHint: '支持发起人、业务编号、表单名称',
      all: '全部',
      approvalRequired: '需要审批',
      approvalNotRequired: '无需审批',
    },
    statuses: {
      all: '全部',
      running: '进行中',
      suspended: '已暂停',
      approved: '已通过',
      rejected: '已拒绝',
      withdrawn: '已撤回',
      terminated: '已终止',
      failed: '失败',
      submitted: '已提交',
      pending_approval: '审批中',
      cancelled: '已取消',
    },
    exportStatuses: {
      pending: '排队中',
      processing: '导出中',
      success: '已完成',
      failed: '失败',
      expired: '已过期',
    },
    kpi: {
      totalSubmissions: '总提交数',
      approvalRate: '通过率',
      rejectRate: '拒绝率',
      avgDuration: '平均耗时',
      runningCount: '审批中',
    },
    trendTitle: '趋势概览',
    distributionTitle: '表单分布',
    instancesTitle: '提交明细',
    exportHistory: '导出记录',
    download: '下载',
    table: {
      form: '表单',
      submitter: '发起人',
      status: '状态',
      node: '当前节点',
      time: '提交时间',
      duration: '耗时',
    },
    settingsTitle: '导出设置',
    exportRetention: '导出保留天数',
    exportRetentionHint: '当前保留 {days} 天，超过时间自动清理。',
    pagination: '第 {page} / {total} 页',
    detail: {
      title: '提交详情',
      status: '状态',
      submitter: '发起人',
      submittedAt: '提交时间',
      approvalRequired: '审批类型',
      formDataTitle: '表单数据',
      formDataEmpty: '暂无表单数据',
      approvalHistoryTitle: '审批历史',
      noApprovalHistory: '暂无审批记录',
      notRequired: '该表单未走审批流程',
      openApproval: '查看审批详情',
      openFormInstance: '查看表单实例',
    },
  },
  allApplications: '所有应用',
  smartHr: '智能人事',
  submitWorkRecord: '提交加班记录',
  recommended: '推荐应用',
  pendingTasksNotice: '您有 {count} 个待审批的任务，请及时处理。',
  viewNow: '立即查看',
  
  // 待审批页面
  pendingPage: {
    title: '待我审批',
    subtitle: '需要您审批的任务',
    noTasks: '暂无待审批任务',
    noTasksDesc: '您没有需要审批的任务',
    taskName: '任务名称',
    businessType: '业务类型',
    createTime: '创建时间',
    actions: '操作',
    viewDetail: '查看详情',
    approve: '通过',
    reject: '拒绝',
    confirmApprove: '确认通过此审批？',
    confirmReject: '确认拒绝此审批？',
    approveSuccess: '审批已通过',
    approveFailed: '审批失败',
    rejectSuccess: '已拒绝',
  },
  
  // 抄送页面
  ccPage: {
    title: '抄送我的',
    subtitle: '抄送给您的流程',
    noInstances: '暂无抄送记录',
    noInstancesDesc: '没有抄送给您的流程',
    businessKey: '业务编号',
    businessType: '业务类型',
    initiator: '发起人',
    status: '状态',
    startTime: '开始时间',
    endTime: '结束时间',
    actions: '操作',
    viewDetail: '查看详情',
    pageTitle: '抄送我的',
    pageSubtitle: '查看抄送给我的审批流程',
    markAsRead: '标记已读',
    batchMarkAsRead: '批量标记已读',
    allCC: '全部抄送',
    unread: '未读',
    read: '已读',
    filterAll: '全部抄送',
    filterUnread: '仅未读',
    loading: '加载中...',
    noCC: '暂无抄送',
    noCCDesc: '当前没有抄送给您的任务',
    markAsReadSuccess: '已标记为已读',
    markAsReadFailed: '标记失败',
    selectTasksFirst: '请先选择要标记的任务',
    batchMarkSuccess: '已标记 {count} 个任务为已读',
    batchMarkFailed: '批量标记失败',
    loadFailed: '加载抄送任务失败',
    view: '查看',
    tableHeaders: {
      readStatus: '状态',
      title: '标题',
      node: '节点',
      initiator: '发起人',
      ccTime: '抄送时间',
      processStatus: '流程状态',
      actions: '操作',
    },
    statusMap: {
      RUNNING: '进行中',
      SUSPENDED: '已暂停',
      COMPLETED: '已完成',
      TERMINATED: '已终止',
      FAILED: '失败',
    },
    pagination: {
      total: '共 {total} 个抄送',
      page: '第 {page} / {totalPages} 页',
      previous: '上一页',
      next: '下一页',
    },
  },
  
  // 我创建的页面
  createdPage: {
    title: '我创建的',
    subtitle: '我发起的审批流程',
    noInstances: '暂无创建记录',
    noInstancesDesc: '您还没有发起过审批',
    businessKey: '业务编号',
    businessType: '业务类型',
    status: '状态',
    startTime: '开始时间',
    endTime: '结束时间',
    actions: '操作',
    viewDetail: '查看详情',
  },

  // 我的申请页面
  initiatedPage: {
    title: '我的申请',
    subtitle: '查看我发起的所有审批申请',
    noInstances: '暂无申请记录',
    noInstancesDesc: '您还没有发起过申请',
    businessKey: '业务编号',
    businessType: '业务类型',
    status: '状态',
    currentNode: '当前节点',
    createTime: '创建时间',
    actions: '操作',
    viewDetail: '查看详情',
    filterByType: '业务类型',
    filterByStatus: '状态',
    allTypes: '全部',
    allStatuses: '全部',
    withdraw: '撤回',
    withdrawing: '撤回中...',
    confirmWithdraw: '确定要撤回此申请吗？',
    withdrawSuccess: '撤回成功',
    withdrawFailed: '撤回失败',
    withdrawNotSupported: '该业务类型暂不支持撤回',
    statusMap: {
      RUNNING: '进行中',
      COMPLETED: '已完成',
      TERMINATED: '已终止',
      SUSPENDED: '已挂起',
      FAILED: '失败',
    },
    unknownType: '未知类型',
    businessTypeOptions: {
      all: '全部',
      FORM_INSTANCE: '表单申请',
      PURCHASE_ORDER: '采购申请',
      EXPENSE_CLAIM: '报销申请',
    },
    statusOptions: {
      all: '全部',
      RUNNING: '进行中',
      COMPLETED: '已完成',
      TERMINATED: '已终止',
    },
    tableHeaders: {
      businessType: '业务类型',
      title: '标题',
      status: '状态',
      currentNode: '当前节点',
      createTime: '创建时间',
      actions: '操作',
    },
  },
  
  // 我已处理页面
  processedPage: {
    title: '我已处理',
    subtitle: '我已审批的任务',
    noTasks: '暂无已处理任务',
    noTasksDesc: '您还没有处理过审批任务',
    taskName: '任务名称',
    businessType: '业务类型',
    result: '审批结果',
    comment: '评论',
    completeTime: '完成时间',
    actions: '操作',
    viewDetail: '查看详情',
  },
  
  // 消息
  withdrawSuccess: '已撤回',
  operationFailed: '操作失败',
  
  // 提交请求页面
  submitRequest: {
    title: '提交请求',
    searchPlaceholder: '请输入应用名称',
    lastEdited: '最近编辑：',
    recommended: '推荐',
    allApplications: '所有应用',
    noFormsAvailable: '暂无可用表单',
    loading: '加载中...',
    categories: {
      uncategorized: '未分类',
      uesProcess: 'UES 流程',
      testProcess: '测试流程',
      attendance: '考勤',
      finance: '财务',
      administration: '行政',
      otherServices: '其他服务提供',
    },
  },
  
  // 审批流程设计器
  designer: {
    setup: '设置',
    // 标签页
    tabs: {
      approver: '审批人',
      actions: '操作设置',
      fields: '字段权限',
      advanced: '高级设置',
    },
    
    // 审批人类型
    approverTypes: {
      fixedUser: '指定成员',
      role: '指定角色',
      department: '部门主管',
      initiatorManager: '发起人上级',
      managerChain: '连续上级审批',
      formField: '部门接口人',
      initiator: '发起人本人',
      selfSelect: '发起人自选',
      formMember: '表单内成员字段',
      connector: '从连接器获取',
    },
    
    // 多人审批方式
    multiApprovalModes: {
      and: {
        label: '会签',
        description: '需所有审批人同意',
      },
      or: {
        label: '或签',
        description: '一名审批人同意即可',
      },
      sequential: {
        label: '依次审批',
        description: '按顺序依次审批',
      },
    },
    
    // 属性面板标签
    labels: {
      nodeName: '节点名称',
      approverType: '审批人类型',
      approvers: '审批人',
      multiApprovalMode: '多人审批方式',
      selectApprovers: '选择审批人',
      selectedCount: '已选择 {count} 人',
      selectRole: '选择角色',
      noRoleSelected: '请选择角色',
      managerLevel: '上级层级',
      levelDescription: '第 {level} 级主管',
      autoApprove: '找不到主管时自动通过',
      skipSameApprover: '跳过已审批的相同审批人',
      allowEditForm: '审批时允许编辑表单',
      dueTime: '审批期限',
      dueTimeUnit: '工作日',
      autoReject: '超时自动拒绝',
      notifyBeforeDue: '到期前提醒',
      notifyDays: '提前天数',
      fieldPermissions: '字段权限',
      readable: '可读',
      editable: '可编辑',
      required: '必填',
      hidden: '隐藏',
      actionButtons: '操作按钮设置',
      enableApprove: '启用"通过"按钮',
      enableReject: '启用"拒绝"按钮',
      enableTransfer: '启用"转交"按钮',
      requireRejectReason: '拒绝时必须填写理由',
      ccUsers: '抄送人',
      selectCCUsers: '选择抄送人',
      ccTiming: '抄送时机',
      ccOnStart: '节点开始时',
      ccOnComplete: '节点完成时',
      approvalTimeout: '审批超时提醒',
      hoursLater: '小时后提醒审批人',
      setZeroForUnlimited: '设为 0 表示不限时',
      autoPass: '自动通过',
      autoPassWhenInitiator: '审批人是发起人时自动通过',
      whenApproverNotFound: '找不到审批人时',
      autoSkip: '自动跳过该节点',
      syncNodeConfig: '节点配置同步',
      customLevel: '自定义：第',
      levelSuffix: '级上级',
      assignToLevel: '该节点将分配给发起人的第 {level} 级上级审批',
      stopCondition: '审批终点条件',
      stopConditionDesc: '（何时停止逐级审批）',
      untilDeptHead: '直到部门负责人',
      untilOrgHead: '直到组织最高负责人',
      untilLevel: '直到第 {level} 级上级',
      chainApprovalTip: '连续审批',
      chainApprovalDesc: '从发起人的直属上级开始，逐级向上审批，直到满足终止条件。',
      chainExample: '示例：小明 → 组长 → 经理 → 总监（部门负责人）',
      noFormFields: '暂无表单字段',
      addFieldsFirst: '请先在表单设计中添加字段',
      managerLevelOptions: {
        level1: '直属上级（第 1 级）',
        level1Desc: '发起人的直接上级',
        level2: '第 2 级上级',
        level2Desc: '发起人上级的上级',
        level3: '第 3 级上级',
        level3Desc: '第 2 级上级的上级',
      },
      actions: {
        approve: '同意',
        reject: '拒绝',
        return: '退回',
        forward: '转交',
        addSign: '加签',
      },
      chainConditions: {
        deptHead: '审批至发起人所在部门的负责人',
        orgHead: '审批至顶层组织负责人',
        levelN: '审批至第 {level} 级上级即停止',
      },
    },
    
    // 帮助文本
    helpTexts: {
      role: '从系统角色中选择审批人',
      initiatorManager: '从发起人的上级中选择固定层级的主管',
      managerChain: '逐级向上审批，直到指定层级',
      formField: '从表单中的部门字段选择该部门的接口人',
      multiApprovalOr: '只要有一个审批人通过即可，其他审批人的任务会自动完成',
      skipSameApprover: '如果审批人已经在前面的节点审批过，则自动跳过当前节点',
    },
    
    // 节点类型
    nodeTypes: {
      userTask: '审批人',
      cc: '抄送人',
      gateway: '条件分支',
      delay: '延时节点',
    },
    
    // 按钮
    buttons: {
      close: '关闭',
      save: '保存',
      cancel: '取消',
      add: '添加',
      delete: '删除',
      edit: '编辑',
      confirm: '确认',
      selectUsers: '选择人员',
      clearSelection: '清空选择',
    },
    
    // 验证消息
    validation: {
      nodeNameRequired: '节点名称不能为空',
      approverTypeRequired: '请选择审批人类型',
      approversRequired: '请选择审批人',
      roleRequired: '请选择角色',
      levelRequired: '请输入主管层级',
      levelMin: '主管层级至少为 1',
    },
    
    // 提示消息
    messages: {
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      deleteConfirm: '确认删除此节点吗？',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
    },
  },

  // 审批操作面板（ApprovalActions.tsx）
  actionPanel: {
    title: '审批操作',
    commentPlaceholder: '请输入审批意见',
    rejectReasonRequired: '请输入驳回理由',
    rejectReasonPlaceholder: '请输入驳回理由（必填）',
    confirmReject: '确认驳回',
    confirmRejectTitle: '确认驳回',
    returnDialogTitle: '退回到指定节点',
    returnNodePlaceholder: '选择退回节点',
    returnReasonPlaceholder: '请输入退回理由',
    returnNodeRequired: '请选择退回节点',
    confirmReturn: '确认退回',
    forwardDialogTitle: '转发给其他人',
    forwardUserPlaceholder: '输入用户ID或搜索',
    forwardReasonPlaceholder: '请输入转发理由',
    forwardUserRequired: '请选择转发人',
    confirmForward: '确认转发',
    approverWithdrawDialogTitle: '审批人撤回',
    approverWithdrawReasonPlaceholder: '请输入撤回理由（必填）',
    approverWithdrawReasonRequired: '请输入撤回理由',
    confirmApproverWithdraw: '确认撤回',
    addSignDialogTitle: '加签',
    addSignUserPlaceholder: '加签人用户ID（多个用英文逗号分隔）',
    addSignTypeBefore: '前加签（先于我审批）',
    addSignTypeAfter: '后加签（在我之后审批）',
    addSignTypeParallel: '并行加签（与我同时审批）',
    addSignUsersRequired: '请输入至少一个加签人',
    confirmAddSign: '确认加签',
    claimConfirmTitle: '认领任务',
    claimConfirmDesc: '认领后此任务将由你独占审批，确认认领？',
    confirmClaim: '认领',
    unclaimConfirmTitle: '取消认领',
    unclaimConfirmDesc: '取消后任务回到候选池，其他候选人可重新认领。',
    confirmUnclaim: '取消认领',
    taskIdRequired: '当前任务 ID 缺失，无法操作',
    operationFailed: '操作失败',
    actionSuccess: {
      approve: '已通过审批',
      reject: '审批已驳回',
      return: '已退回到指定节点',
      forward: '已转发给其他人',
      approverWithdraw: '审批操作已撤回',
      addSign: '加签成功',
      claim: '已认领任务',
      unclaim: '已取消认领',
    },
  },
};

export type ApprovalsTranslations = typeof approvalsZh;
